import React from "react";
import PropTypes from "prop-types";
import Styled from "./Styled";
import NavItem from "./NavItem";
import { Trans } from 'components';

const propTypes = {
  videos: PropTypes.array.isRequired,
  active: PropTypes.number.isRequired,
  visited: PropTypes.array.isRequired,
};

class AsideContainer extends React.Component {
  render() {
    const { videos, active, visited } = this.props;
    return (
      <Styled.Container>
        <Styled.Heading>
          <div>
            <h3>
              <Trans>Przewodnik po aplikacji</Trans> <span>Nebula</span>
            </h3>
          </div>
        </Styled.Heading>
        <Styled.Nav>
          <div>
            {videos.map(video => (
              <NavItem
                key={video.id}
                timeLength={video.length}
                title={video.title}
                index={video.id}
                active={video.id === active}
                visited={visited.includes(video.id)}
              />
            ))}
          </div>
        </Styled.Nav>
      </Styled.Container>
    );
  }
}

AsideContainer.propTypes = propTypes;
AsideContainer.displayName = "#pages/tutorial/Aside#";
export default AsideContainer;



// WEBPACK FOOTER //
// ./src/pages/tutorial/aside/Aside.jsx